import { isAndroid } from '@utiles/device';

export default {
  data() {
    // 判断是否是全面屏
    const judgeBigScreen = () => {
      //  window.screen.height为屏幕高度
      //  window.screen.availHeight 为浏览器 可用高度
      let rate = window.screen.height / window.screen.width;
      let limit =
        window.screen.height == window.screen.availHeight ? 1.8 : 1.65; // 临界判断值
      return rate > limit;
    };

    return {
      showSafePadding: judgeBigScreen(),
      isLandscapeScreen: !portraitScreen(true)
    };
  },
  methods: {
    portraitScreen(init) {
      if (isAndroid()) {
        var res = init
          ? window.innerHeight > window.innerWidth
          : window.innerHeight < window.innerWidth;
        return res;
      }
      return window.orientation === 0;
    },
    setIsLandscapeScreen() {
      this.isLandscapeScreen = !this.portraitScreen(true);
      console.log('是否竖屏：' + this.isLandscapeScreen);
    },
    listenerScreenChange() {
      window.addEventListener('orientationchange', this.setIsLandscapeScreen);
    },
    removeListenerScreenChange() {
      window.removeEventListener(
        'orientationchange',
        this.setIsLandscapeScreen
      );
    }
  },
  created() {
    this.listenerScreenChange();
  },
  beforeDestroy() {
    this.removeListenerScreenChange();
  }
};
